import { render, staticRenderFns } from "./ProfileEditPassword.vue?vue&type=template&id=2257453b&scoped=true&"
import script from "./ProfileEditPassword.vue?vue&type=script&lang=js&"
export * from "./ProfileEditPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257453b",
  null
  
)

export default component.exports